import { useEffect} from "react";
import { connect } from "react-redux";
import { tokenize } from "../../actions/auth";
import { useNavigate } from "react-router-dom";
import { surveyTokenizeDestination } from "../../utils/survey-tokenize";

const Tokenize = ({ tokenize }) => {
    
    const navigate = useNavigate();

    useEffect(() => {
        const persistData = async () => {
            // Retrieve URL parameters
            const params = new URLSearchParams(window.location.search);
            const token = params.get("t");
            const instance = params.get("i");
            const destination = surveyTokenizeDestination(params.get("next"));

            if (!token || !instance) return;

            if (await tokenize(instance, token)) {
                navigate(destination, { replace: true });
            }
        }
        persistData();
    }, [tokenize, navigate]);

    return (
        <main aria-live="polite" className="d-flex min-vh-100 align-items-center justify-content-center">
            <p>Opening your survey&hellip;</p>
        </main>
    );
    
}

export default connect(null, { tokenize })(Tokenize);

